<template>
  <div class="container oferta-V2">
    <wrap-container class="title-container">
      <div class="oferta-container padding-17-left-right">
        <wrap-container class="w100 ">
          <wrap-container class="col1">
            <p id="titulo" class="titulo hola">
              <span data-obfuscate>{{ nombre }}</span
              >, empezá a cobrar tu sueldo en BBVA
            </p>
            <p id="subtitulo" class="titulo tenemos">
              Si abrís tu cuenta sueldo, podés acceder a:
            </p>
          </wrap-container>
        </wrap-container>
      </div>
    </wrap-container>
    <div class="oferta-container padding-17-left-right">
      <div class="oferta-card">
        <form-validator class="form-container">
          <wrap-container class="w100  ">
            <div class="oferta">
              <product-container
                class="clickable"
                @click="$router.push(config.pasos.oferta.pasoSiguiente)"
                :title="nombrePaquete"
                :tarjetas="beneficiosTC.incluye.tarjetas"
                :listado-tarjetas="beneficiosTC.caracteristicas.tarjetas"
                quantumObfuscate
              />
              <p v-if="beneficiosTC.disclaimer" class="disclaimer">
                {{ beneficiosTC.disclaimer }}
              </p>
            </div>
          </wrap-container>
        </form-validator>

        <wrap-container>
          <div class="desplegable-container">
            <div class="desplegable" @click="toggleText">
              <p class="badge">100% bonificado</p>
              <div class="desplegable-flex">
                <div>
                  <h2>Sin costo de mantenimiento</h2>
                  <p>
                    Costo sin bonificación: $
                    <span data-obfuscate>
                      {{ mantenimiento }}
                    </span>
                  </p>
                </div>
                <p :class="this.arrowStatus ? 'arrowActive' : null">
                  <img
                    src="@/assets/img/ofertaNomina/icons/arrow-down.svg"
                    alt="arrow-down"
                  />
                </p>
              </div>
            </div>
            <transition name="modal">
              <div v-if="isTextVisible" class="desplegable-content">
                <p>
                  Tu cuenta tiene una bonificación del 100% mientras cobres tu
                  sueldo en BBVA.
                </p>
                <p>
                  Si dejás de acreditar tu sueldo en BBVA y tenés contratadas
                  tarjetas de crédito, se cobrará el costo de mantenimiento
                  todos los meses.
                </p>

                <a
                  href="https://www.bbva.com.ar/personas/tabla-de-comisiones.html"
                  target="_blank"
                  ><h2>Consultar costos vigentes</h2></a
                >
              </div>
            </transition>
          </div>
        </wrap-container>
      </div>
    </div>

    <OfferTimeline
      :userIsClient="userIsClient"
      :steps="config.pasos.oferta.steps"
      :tituloTimeline="config.pasos.oferta.tituloTimeline"
      :disclaimerTimeline="config.pasos.oferta.disclaimerTimeline"
    />

    <BannerBienvenidaOferta
      v-if="config.pasos.oferta.banners.bannerBienvenida"
      :title="config.pasos.oferta.banners.bannerBienvenida.title"
      :codigoPaquete="codigoPaquete"
    />
    <BannerDespegarOferta
      v-if="config.pasos.oferta.banners.bannerDespegar2"
      :title="config.pasos.oferta.banners.bannerDespegar2.title"
      :subtitle="config.pasos.oferta.banners.bannerDespegar2.subtitle"
      :subtitle2="config.pasos.oferta.banners.bannerDespegar2.subtitle2"
    />
    <BannerFinanzasOferta
      v-if="config.pasos.oferta.banners.bannerFinanzas"
      :title="config.pasos.oferta.banners.bannerFinanzas.title"
      :subtitle="config.pasos.oferta.banners.bannerFinanzas.subtitle"
    />
    <BannerMODOOferta
      v-if="config.pasos.oferta.banners.bannerMODO"
      :title="config.pasos.oferta.banners.bannerMODO.title"
      :subtitle="config.pasos.oferta.banners.bannerMODO.subtitle"
    />
    <BannerMasComodo
      v-if="config.pasos.oferta.banners.bannerMasComodo"
      :title="config.pasos.oferta.banners.bannerMasComodo.title"
      :subtitle="config.pasos.oferta.banners.bannerMasComodo.subtitle"
    />
    <div class="sales-button-container">
      <sales-button
        class="sales-button"
        ref="salesbutton"
        label="Continuar"
        analyticsName="continuar"
        @click.native="continuar"
      />
    </div>
  </div>
</template>

<script>
import ProductContainer from "@/components/core/custom/ProductContainerNoCliente";
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import { nombresPaquetes } from "@/config/constants/packagesCodes";
import BannerBienvenidaOferta from "@/components/core/custom/BannerBienvenidaOferta.vue";
import BannerDespegarOferta from "@/components/core/custom/BannerDespegarOferta.vue";
import BannerFinanzasOferta from "@/components/core/custom/BannerFinanzasOferta.vue";
import BannerMODOOferta from "@/components/core/custom/BannerMODOOferta.vue";
import BannerMasComodo from "@/components/core/custom/BannerMasComodo.vue";
import OfferTimeline from "@/components/core/custom/OfferTimeline.vue";
import SalesButton from "@/components/core/SalesButton";
import bus from "../bus";
import { get } from "../utils";

export default {
  name: "Oferta",
  components: {
    ProductContainer,
    WrapContainer,
    FormValidator,
    BannerBienvenidaOferta,
    BannerDespegarOferta,
    BannerFinanzasOferta,
    BannerMODOOferta,
    BannerMasComodo,
    OfferTimeline,
    SalesButton
  },
  data() {
    return {
      model: this.$store.getters.getConsulta(),
      isTextVisible: false,
      arrowStatus: false
    };
  },
  methods: {
    toggleText() {
      this.isTextVisible = !this.isTextVisible;
      this.arrowStatus = !this.arrowStatus;
    },
    continuar() {
      bus.$emit("analytics:event", {
        event: "interaction_link",
        eventData: {
          name: "continuar",
          level2: get(this.currentView, "config.analyticsName", ""),
          level3: "paquete"
        }
      });
      this.$router.push(this.config.pasos.oferta.pasoSiguiente);
    }
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (!this.$store.state.dataOferta) {
      this.$router.push("/");
    }
  },
  computed: {
    oferta() {
      if (this.$store.state.dataOferta.oferta.valid) {
        return this.$store.state.dataOferta.oferta;
      }
      return {};
    },
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    infoOferta() {
      return this.$store.getters.getOferta();
    },
    codigoPaquete() {
      if (!this.infoOferta.paquetes) {
        return false;
      } else {
        return this.infoOferta.paquetes[0].tipoPaquete;
      }
    },
    userIsClient() {
      const clientInfo = this.$store.getters.getDataOferta();
      if (
        !clientInfo ||
        !clientInfo.esCliente ||
        !clientInfo.esCliente.respuesta
      ) {
        return false;
      }
      return clientInfo.esCliente.respuesta === "CLIENTE";
    },
    beneficiosTC() {
      return this.$store.getters.getPaquetesBeneficios();
    },
    nombrePaquete() {
      return nombresPaquetes(this.beneficiosTC.caracteristicas.tipoPaquete);
    },
    items() {
      return this.beneficiosTC.incluye.items;
    },
    tarjetaDeCredito() {
      return this.beneficiosTC.caracteristicas.nombreTarjetas;
    },
    beneficios() {
      return this.beneficiosTC.beneficios.items;
    },
    mantenimiento() {
      return this.beneficiosTC.caracteristicas.mantenimiento;
    }
  }
};
</script>
<style scoped>
.arrowActive {
  transform: rotate(180deg);
}
.content-bonus-items {
  margin-left: 17px;
}
.bonus-items {
  margin-top: 50px;
  padding-bottom: 20px;
}
div.container {
  height: 100%;
}

.oferta-container {
  max-width: 100%;
  margin: 0 auto;
}

div.oferta {
  display: block;
  max-width: 100%;
  margin-bottom: 0px;
}

input {
  padding: 0px;
}

.sales-button-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  height: 80px;
  background-color: #fff;
  display: flex;
}

.sales-button-container div.container {
  height: auto;
}

.sales-button {
  max-width: 104px;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
}

p#subtitulo {
  margin-bottom: 37px;
}

p.disclaimer {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #666;
  margin-top: -44px;
  margin-bottom: 44px;
}

.que-incluye {
  margin-bottom: 16px;
  margin-top: 0px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  margin-left: 17px;
  line-height: 1.6;
}

.que-incluye-sub {
  margin-left: 17px;
  font-size: 14px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

.mobile {
  display: none;
}

.caja {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  color: #535353;
}

div.container > .title-container {
  background-color: #043263;
  margin-top: -43px;
  padding-top: 64px;
  height: 351px;
}

#titulo {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin-bottom: 24px;
  line-height: 48px;
}

#subtitulo {
  font-size: 24px;
  font-weight: 300;
  color: #fff;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 16px;
  padding-top: 10px;
}

.form-container {
  padding: 24px 16px 0px 16px;
}

.oferta-card {
  margin: -130px auto 0;
  background: white;
  max-width: 929px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.desplegable-container {
  position: relative;
  cursor: pointer;
}

.desplegable {
  background-color: #f4f4f4;
  padding: 34px 16px 16px 16px;
  border-bottom: 1px solid #c2c0c0;
}

.desplegable-content {
  background-color: #f4f4f4;
  padding: 4px 16px 16px;
}

.desplegable-container p {
  font-size: 14px;
}

.desplegable-content > p {
  margin: 12px 0;
}

.desplegable-container h2 {
  font-size: 22px;
  font-weight: bold;
  color: #1973b8;
  margin: 4px 0;
}

.badge {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #1464a5;
  border-radius: 0 0 10px 0;
  color: white;
  padding: 4px 8px 4px 16px;
  font-size: 12px;
  font-weight: bold;
}

.desplegable-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
p#titulo,
p#subtitulo {
  max-width: 929px;
  margin: auto;
}

@media screen and (max-width: 600px) {
  .container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  .container > div:nth-child(1) {
    order: 0;
  }

  .container > div:nth-child(2) {
    order: 1;
  }

  .container > div:nth-child(3) {
    order: 2;
  }

  .container > div:nth-child(4) {
    order: 3;
  }

  .container > div:nth-child(5) {
    order: 5;
  }

  .container > div:nth-child(6) {
    order: 4;
  }

  .container > div:nth-child(7) {
    order: 5;
  }
  .container > div:nth-child(8) {
    order: 6;
  }
  .container > div:nth-child(9) {
    order: 7;
  }

  #titulo {
    font-size: 21px;
    line-height: 32px;
  }
  #subtitulo {
    font-size: 26px;
  }
  .que-incluye {
    margin-top: 32px;
  }
  .que-incluye-sub {
    line-height: 1.6;
  }
  .mobile {
    display: block;
    margin-top: -20px;
    margin-bottom: 34px;
  }
  .margin-benefits-m {
    margin-left: -15px;
    margin-top: 32px;
  }
  .margin-bonus-m {
    margin-top: -15px;
  }
  p#subtitulo {
    margin-bottom: unset;
    padding-bottom: 37px;
    font-size: 14px;
  }
  .oferta-card {
    margin: -170px auto 0;
  }

  .oferta-container {
    margin: 0;
  }

  .desplegable-container h2 {
    font-size: 15px;
    line-height: 24px;
  }

  .desplegable-container p {
    font-weight: 600;
  }
  div.container.container-dark {
    position: relative;
    bottom: 75px;
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .sales-button {
    max-width: 100%;
  }

  .mobile {
    display: none;
  }
}
@media screen and (min-width: 1025px) {
  .oferta .sales-button {
    max-width: 120px;
    display: block;
    margin-left: auto !important;
    margin-right: auto;
  }
  .mobile {
    display: none;
  }
}
</style>
